import { render, staticRenderFns } from "./NearbyGymsCarousel.vue?vue&type=template&id=4d7dec34"
import script from "./NearbyGymsCarousel.vue?vue&type=script&lang=js"
export * from "./NearbyGymsCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports